module.exports = __webpack_public_path__ + "e660dd3a13ef98c2023aea3a5b679a94.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-flag-kit/assets/AG.svg
// module id = kmXw
// module chunks = 0